const LocationReviewsData = [
  {
    "customer": "Michael S.",
    "review": "Exceptional service! The team was punctual, friendly, and thoroughly cleaned my dryer vent. I noticed improved drying efficiency right away.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Jessica T.",
    "review": "AttiAir exceeded my expectations. They cleaned the dryer vent, and I can already feel the difference in drying time. Highly recommend!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Emily R.",
    "review": "Great experience from start to finish. The technicians were knowledgeable, explained the process, and left everything spotless.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Anthony J.",
    "review": "Efficient, professional, and reliable. I appreciate how the team paid attention to every detail. My dryer is working much better.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Robert K.",
    "review": "Quick response time and thorough dryer vent cleaning. I’m already seeing faster drying times, and it’s all thanks to AttiAir.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Sarah P.",
    "review": "They did an amazing job with my dryer vent. The team was respectful of my home and got the job done quickly.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Lisa M.",
    "review": "Very impressed with the quality of service. The technicians were polite and took care of everything efficiently.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Kevin H.",
    "review": "AttiAir provided excellent service, and I noticed less lint buildup in the dryer immediately after cleaning.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Diana F.",
    "review": "This was my first time using them, and I’ll definitely call again. Great value and fantastic results.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Eric W.",
    "review": "The technicians were professional and completed the cleaning quickly. My dryer is running smoother now.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Samantha L.",
    "review": "The team did a fantastic job cleaning our dryer vent. It was long overdue, and now the dryer works much better!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Tom C.",
    "review": "AttiAir saved us from a potential fire hazard by thoroughly cleaning the dryer vent. Very grateful!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Olivia N.",
    "review": "Highly recommend their dryer vent cleaning service. They arrived on time and finished the job without any mess.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Jason B.",
    "review": "I could tell they knew exactly what they were doing. My dryer runs more efficiently, thanks to their excellent service.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Maria S.",
    "review": "AttiAir did an amazing job cleaning the dryer vent. I never realized how much lint could accumulate over time!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Peter V.",
    "review": "Quick, efficient, and friendly service. I’ll be scheduling regular dryer vent cleanings with them.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Vanessa D.",
    "review": "Outstanding service! The techs were knowledgeable and explained the importance of regular dryer vent cleaning.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Ben A.",
    "review": "I had a significant buildup in my dryer vent, but BHO handled it well. Great job!",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Amy G.",
    "review": "They were able to schedule me quickly and did a thorough job. I appreciate their attention to safety.",
    "service": "Dryer Vent Cleaning"
  },
  {
    "customer": "Rachel K.",
    "review": "Very pleased with the dryer vent cleaning. The team was professional, and I can already tell the difference in drying time.",
    "service": "Dryer Vent Cleaning"
  }
]
  
export default LocationReviewsData;
